import { c as _c } from "react/compiler-runtime";
import { FiCheck } from 'react-icons/fi';
import type { IPropsTopCardPlan } from '../home.interface';
export const PricingTopCards = data => {
  const $ = _c(30);
  const {
    planData
  } = data;
  let t0;
  if ($[0] !== planData.pack) {
    t0 = <div className="flex text-left text-lg font-semibold text-[#616366]">{planData.pack}</div>;
    $[0] = planData.pack;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== planData.currency) {
    t1 = <div className="text-[44px] font-semibold">{planData.currency}</div>;
    $[2] = planData.currency;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== planData.amount) {
    t2 = <div className="text-[44px] font-semibold">{planData.amount}</div>;
    $[4] = planData.amount;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== planData.duration) {
    t3 = <div className="my-auto text-2xl  font-semibold text-[#3d3e40]">{planData.duration}</div>;
    $[6] = planData.duration;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <div className="flex">{t1}{t2}{t3}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = `text-left text-sm font-normal text-[#616366] ${planData.amountDescription ? "visible" : "invisible"}`;
  const t6 = planData.amountDescription || "\xA0";
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t0 || $[16] !== t4 || $[17] !== t7) {
    t8 = <div className="flex flex-col">{t0}{t4}{t7}</div>;
    $[15] = t0;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = `mb-3 mt-2 text-left text-base font-semibold not-italic text-[#616366] lg:mt-9
           ${planData.planHeading ? "visible" : "hidden"}`;
  const t10 = planData.planHeading || "\xA0";
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className={t9}>{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== planData.planDesc) {
    t12 = planData.planDesc.map(_temp);
    $[22] = planData.planDesc;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = <div className="mb-7 flex flex-col">{t11}{t12}</div>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t8) {
    t14 = <div className="flex flex-col ">{t8}{t13}</div>;
    $[27] = t13;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
export default PricingTopCards;
function _temp(value, index) {
  return <div className="row-auto mt-2 flex items-center px-2 md:px-0" key={index}><FiCheck className="mr-1 inline h-5 w-4 shrink-0 text-[#67B5E5]" /><span className="ml-3 text-start text-[#616366]">{value}</span></div>;
}